export function getRGBFromXYZ(parX, parY, parZ) {
    let x = parseFloat(parX);
    let y = parseFloat(parY);
    let z = parseFloat(parZ);

    let neededDivision100 = x > 1 || y > 1 || z > 1; // Old format < 1, new format > 1

    // Normalize XYZ values
    let var_X = x / (neededDivision100 ? 100 : 1);
    let var_Y = y / (neededDivision100 ? 100 : 1);
    let var_Z = z / (neededDivision100 ? 100 : 1);

    // Convert XYZ to linear RGB
    let var_R = var_X * 3.2406 + var_Y * -1.5372 + var_Z * -0.4986;
    let var_G = var_X * -0.9689 + var_Y * 1.8758 + var_Z * 0.0415;
    let var_B = var_X * 0.0557 + var_Y * -0.2040 + var_Z * 1.0570;

    // Apply gamma correction (sRGB)
    var_R = var_R > 0.0031308 ? 1.055 * Math.pow(var_R, 1 / 2.4) - 0.055 : 12.92 * var_R;
    var_G = var_G > 0.0031308 ? 1.055 * Math.pow(var_G, 1 / 2.4) - 0.055 : 12.92 * var_G;
    var_B = var_B > 0.0031308 ? 1.055 * Math.pow(var_B, 1 / 2.4) - 0.055 : 12.92 * var_B;

    // Scale to 0-255 and clamp values
    let sR = Math.max(0, Math.min(255, Math.round(var_R * 255)));
    let sG = Math.max(0, Math.min(255, Math.round(var_G * 255)));
    let sB = Math.max(0, Math.min(255, Math.round(var_B * 255)));

    return `rgb(${sR}, ${sG}, ${sB})`;
}